import { useEffect } from 'react';
import { useAppData } from '@/contexts/AppDataContext';

export const AndroidSmartBanner = () => {
  const { config } = useAppData();

  useEffect(() => {
    if (!config) return;

    // Verifica se é Android
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;

    if (!isAndroid) return;

    const packageName = config.googlePlay?.packageName;
    const playStoreUrl = config.googlePlay?.url?.trim();
    if (!packageName || !playStoreUrl) return;

    // Função para verificar se deve mostrar o banner
    const shouldShowBanner = () => {
      const dismissedData = localStorage.getItem("appBannerDismissed");
      const visitCount = parseInt(localStorage.getItem("appBannerVisitCount") || "0");

      if (!dismissedData) {
        // Primeira vez - sempre mostrar
        return true;
      }

      try {
        const data = JSON.parse(dismissedData);
        const dismissedDate = new Date(data.date);
        const now = new Date();
        const daysSinceDismissed = (now.getTime() - dismissedDate.getTime()) / (1000 * 60 * 60 * 24);

        // Mostrar após 7 dias OU a cada 10 visitas
        return daysSinceDismissed >= 7 || visitCount >= 10;
      } catch {
        // Se houver erro no parsing, mostrar
        return true;
      }
    };
    // Função para abrir o app ou redirecionar para a Play Store
    // Só será chamada quando o usuário clicar no botão (user interaction)
    const openApp = () => {
      const intentUrl = `intent://open#Intent;scheme=${packageName};package=${packageName};end`;
      let hidden = false;

      const handleVisibilityChange = () => {
        hidden = document.hidden;
      };

      document.addEventListener('visibilitychange', handleVisibilityChange);

      try {
        // Tenta abrir o app via intent (só chamado após interação do usuário)
        window.location.href = intentUrl;

        // Se o app não abrir após 1s, redireciona para Play Store
        setTimeout(() => {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
          if (!hidden) {
            window.location.href = playStoreUrl;
          }
        }, 1000);
      } catch (error) {
        // Se houver erro, redireciona para Play Store
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.location.href = playStoreUrl;
      }
    };

    if (shouldShowBanner()) {
      // Não verifica se o app está instalado automaticamente
      // O banner sempre mostra "Instalar" e tenta abrir o app quando clicado
      // Se o app não estiver instalado, redireciona para Play Store
      const buttonText = "Instalar";
      const buttonAction = openApp;

      const banner = document.createElement("div");
      banner.id = "smartBanner";
      banner.style.cssText = `
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fcfcfc;
        color: #00000;
        display: flex;
        align-items: center;
        padding: 12px;
        font-family: sans-serif;
        z-index: 9999;
      `;

      const appIcon = config.icon?.light || '/icon.svg';

      banner.innerHTML = `
        <img src="${appIcon}" alt="App Icon" style="width:48px;height:48px;border-radius:8px;margin-right:12px;">
        <div style="flex:1">
          <strong>Baixe nosso app</strong><br>
          Experimente uma versão mais rápida no Android
        </div>
        <button id="openApp" style="
          background:#03875F;
          color:#ffffff;
          border:none;
          padding:8px 12px;
          border-radius:6px;
          margin:4px;
          font-weight:bold;
          cursor:pointer;
          margin-right:8px;">${buttonText}</button>
        <button id="dismissBanner" style="
          background:none;
          border:none;
          color:#aaa;
          font-size:18px;
          margin:8px;
          cursor:pointer;">×</button>
      `;

      document.body.appendChild(banner);

      const openAppBtn = document.getElementById("openApp");
      const dismissBannerBtn = document.getElementById("dismissBanner");

      if (openAppBtn) {
        openAppBtn.addEventListener("click", buttonAction);
      }

      if (dismissBannerBtn) {
        dismissBannerBtn.addEventListener("click", function () {
          banner.remove();

          // Salvar data de dismiss e incrementar contador de visitas
          const dismissedData = {
            date: new Date().toISOString()
          };
          localStorage.setItem("appBannerDismissed", JSON.stringify(dismissedData));

          // Incrementar contador de visitas
          const visitCount = parseInt(localStorage.getItem("appBannerVisitCount") || "0");
          localStorage.setItem("appBannerVisitCount", (visitCount + 1).toString());
        });
      }
    } else {
      // Incrementar contador de visitas mesmo quando não mostra o banner
      const visitCount = parseInt(localStorage.getItem("appBannerVisitCount") || "0");
      localStorage.setItem("appBannerVisitCount", (visitCount + 1).toString());
    }
  }, [config]);

  return null; // Este componente não renderiza nada visualmente
};
